import React from 'react';
import {graphql, useFragment} from 'react-relay';
import styled from 'styled-components';
import type {ScheduleDrawerContent_scheduleSet$key} from './__generated__/ScheduleDrawerContent_scheduleSet.graphql';
import type {ScheduleSetSnapshot} from './scheduleMutations';
import {ScheduleList} from './ScheduleList';
import {ScheduleSetToggle} from './ScheduleSetToggle';

const Content = styled.div`
	padding: 4px 20px 24px;
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const fragment = graphql`
	fragment ScheduleDrawerContent_scheduleSet on ScheduleSet {
		id
		consumer
		enabled
		schedules {
			id
			scheduleId
			frequency
			dayOfMonth
			weekdays
			timeOfDay
			timezone
		}
	}
`;

type ScheduleDrawerContentProps = {
	scheduleSet: ScheduleDrawerContent_scheduleSet$key;
	name: string;
	onReload: () => void;
};

export const ScheduleDrawerContent = ({scheduleSet, name, onReload}: ScheduleDrawerContentProps): JSX.Element => {
	const set = useFragment(fragment, scheduleSet) as unknown as ScheduleSetSnapshot;
	return (
		<Content>
			<ScheduleSetToggle set={set} name={name} onReload={onReload} />
			<ScheduleList set={set} onReload={onReload} />
		</Content>
	);
};
